module.exports = __webpack_public_path__ + "static/media/lead-managementcrm.2011a8ea.svg";